<template>
  <div id="app">
    <v-app>
      <div class="main_block">
        <NewMainHeader />
        <router-view :key="$route.fullPath" />
        <DoormatComponent />
        <NewMainFooter />
      </div>
    </v-app>
  </div>
</template>

<script>
import { setLanguage } from "~/axios";
import NewMainHeader from "~/components/NewMainHeader.vue";
import NewMainFooter from "~/components/NewMainFooter.vue";
import DoormatComponent from "~/components/DoormatComponent.vue";
import { useOidcStore } from "vue3-oidc";
const { state } = useOidcStore();
const DEFAULT_TITLE = "Edusources";

export default {
  dependencies: ["$window", "$log"],
  components: {
    NewMainHeader,
    NewMainFooter,
    DoormatComponent,
  },
  computed: {
    route() {
      return this.$router.currentRoute;
    },
  },
  watch: {
    async "$i18n.locale"(newLocale) {
      setLanguage(newLocale);
      let user = (await state.value.userManager?.getUser()) || state.user;
      if (user) {
        this.$store.dispatch("setUser", user);
      }
    },
  },
  created() {
    this.$store.dispatch("getFilterCategories");
    this.$store.dispatch("getVocabularies");
  },
  methods: {
    isDemoEnvironment() {
      return (
        this.$window.location.hostname.indexOf("acc.") >= 0 ||
        new URLSearchParams(this.$window.location.search).get("demo")
      );
    },
    isMBOEnvironment() {
      return this.$window.location.hostname.indexOf("mbo.") >= 0;
    },
  },
  metaInfo: {
    title: DEFAULT_TITLE,
    titleTemplate: (titleChunk) => {
      return titleChunk && titleChunk !== DEFAULT_TITLE ? `${titleChunk} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    },
  },
};
</script>

<style lang="less">
@import "styles/normalize.css";
@import "variables.less";
@import "styles/common.less";
@import "styles/forms.less";
@import "styles/vuetify-overrides.less";
</style>
